import { isProduction } from './env';

const MAGIC_PUBLISHABLE_KEY_PROD = 'pk_live_BF46F38DC6A83E7C';
const MAGIC_PUBLISHABLE_KEY_DEV = 'pk_live_74F1D778311B9D92';

export const getMagicPubKey = () => {
    return isProduction() ? MAGIC_PUBLISHABLE_KEY_PROD : MAGIC_PUBLISHABLE_KEY_DEV;
};
